//lista de los categorias que nos ofrece la aplicación
// a lo que es se podra agregar mas modelos de categorias.
//  Listas
// =====================================================

import useFunctionInfo from "@/Hooks/useDataInformation/useFunctionInfo";
import type {
  Categories,
} from "@/Models/MListCategories/Categories";
import type {
  MSubCategoryHijaSubcategoryV2,
} from "@/Models/MSubCategories/MPLPCategory";
import { useEffect, useState } from "react";

export const useDepartamentCategories = (categorie: string) => {
  const { data: fetchedList = [], loading: isLoadings } = useFunctionInfo<
    MSubCategoryHijaSubcategoryV2[]
  >(`/DepartementCategories?subcategory=${categorie}`);

  //const [listCategory, setListCategory] = useState<CategoriesV2[]>([]);
  const [listCategory, setListCategory] = useState<
    MSubCategoryHijaSubcategoryV2[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isLoadings && fetchedList) {
      // Retardo de 2 segundos
      setListCategory(fetchedList);
      setIsLoading(isLoadings);
    }
  }, [fetchedList, isLoading]);
  return {
    listCategory,
    isLoadin: isLoading || isLoadings,
  };
};

export const useListaCategoria = () => {
  const { data: fetchedList = [], loading: isLoadings } = useFunctionInfo<
    Categories[]
  >("/Categorias?name=electronica");

  const [listCategory, setListCategory] = useState<Categories[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchedLists = Array.isArray(fetchedList) ? fetchedList.length : 0;
    const fetchedListData = Array.isArray(fetchedList) ? fetchedList : [];
    // Solo ejecutamos el setTimeout si ya se cargaron los datos
    if (!isLoadings && fetchedLists > 0) {
      const timer = setTimeout(() => {
        setListCategory(fetchedListData);
        setIsLoading(isLoadings);
      }, 2000); // Retardo de 2 segundos

      return () => clearTimeout(timer); // Limpiar el timeout si el componente se desmonta
    }
  }, [fetchedList, isLoading]);

  return {
    listCategory,
    isLoading,
  };
};

export const useListaCategoriaV2 = () => {
  const { data: fetchedList = [], loading: isLoadings } = useFunctionInfo<
    Categories[]
  >("/Categorias?home=lista");

  const [listCategory, setListCategory] = useState<Categories[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchedLists = Array.isArray(fetchedList) ? fetchedList.length : 0;
    const fetchedListData = Array.isArray(fetchedList) ? fetchedList : [];
    // Solo ejecutamos el setTimeout si ya se cargaron los datos
    if (!isLoadings && fetchedLists > 0) {
      setListCategory(fetchedListData);
      setIsLoading(isLoadings);
      //const timer = setTimeout(() => {
      //}, 2000); // Retardo de 2 segundos

      //return () => clearTimeout(timer); // Limpiar el timeout si el componente se desmonta
    }
  }, [fetchedList, isLoading]);

  return {
    listCategory,
    isLoading,
  };
};
